import { render, staticRenderFns } from "./BookingInputVehicleView.vue?vue&type=template&id=d952fd8a&scoped=true&"
import script from "./BookingInputVehicleView.vue?vue&type=script&lang=js&"
export * from "./BookingInputVehicleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d952fd8a",
  null
  
)

export default component.exports